import { render } from "./view-business-card.vue?vue&type=template&id=e562e24a&scoped=true"
import script from "./view-business-card.vue?vue&type=script&lang=js"
export * from "./view-business-card.vue?vue&type=script&lang=js"

import "./view-business-card.vue?vue&type=style&index=0&id=e562e24a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e562e24a"]])

export default __exports__